module.exports = __webpack_public_path__ + "static/media/register-bg.73721e25.svg";